const themes = ["light", "dark", "system"];
export {
  themes as default
};
